import { render } from "./main-collection.vue?vue&type=template&id=2ca3def9"
import script from "./main-collection.vue?vue&type=script&lang=js"
export * from "./main-collection.vue?vue&type=script&lang=js"

import "./main-collection.vue?vue&type=style&index=0&id=2ca3def9&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__